import List from "@/components/list";

const Table = args => {

  const { listeners } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const toDetail = listeners["toDetail"] || function () { };
  const RCsortChange = listeners["sort-change"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="deal-group">
        <el-button
          class="no-padding"
          size="small"
          type="text"
          onClick={() => {
            toDetail(item);
          }}
        >
          查看详情
        </el-button>
      </div>
    );
  };

  const tableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "专题名称",
      prop: "subjectName",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "展示终端",
      prop: "displayTypeName",
      minWidth: "120"
    },
    {
      label: "总学习人数",
      prop: "learnTotalCount",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "已完成学习人数",
      prop: "learnCompleteCount",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "正学习人数",
      prop: "studyCount",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "实际播放量",
      prop: "playNum",
      minWidth: "100",
      sortable: "custom",
      showOverflowTooltip: true,
    },
    // {
    //   label: "收藏",
    //   prop: "collectCount",
    //   minWidth: "100",
    //   showOverflowTooltip: true
    // },
    {
      label: "操作",
      width: "100",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  if (args.props.userType == -1 && args.props.deptLevelCode == "001") {
    tableConfig.splice(2, 0, {
      label: "所属分院",
      prop: "academyName",
      minWidth: "100",
      showOverflowTooltip: true
    });
  }
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={tableConfig}
      onSortChange={RCsortChange}
    />
  );
};

export default Table;
